import styled from 'astroturf/react'
import { useSelector } from 'react-redux'
const successColor = 'var(--color-success, #038164)'
import { CheckCircleIcon } from '@calendly/ui/components/icons'
import { TitleText } from '@calendly/ui/components/typography'

import Profile from 'components/profile'
import { eventSelector } from 'selectors'
import { useI18n } from 'locales'
import _Header from "confirmation_header-Header.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/cancellation/cancellation_components/confirmation_header.js?styleId=Header";
import _TitleWrapper from "confirmation_header-TitleWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/cancellation/cancellation_components/confirmation_header.js?styleId=TitleWrapper";
import _IconContainer from "confirmation_header-IconContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/cancellation/cancellation_components/confirmation_header.js?styleId=IconContainer";


const Header = /*#__PURE__*/styled('div', null, {
  displayName: "Header",
  styles: _Header
})

const TitleWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "TitleWrapper",
  styles: _TitleWrapper
})

const IconContainer = /*#__PURE__*/styled('div', null, {
  displayName: "IconContainer",
  styles: _IconContainer
})

export const CancellationConfirmationHeader = () => {
  const { i18n } = useI18n()
  const event = useSelector(eventSelector)
  const profile = event.scheduled_profile

  return (
    <Header data-component="confirmation-header">
      <Profile
        avatar={profile.avatar_url}
        name={profile.name}
        logoUrl={profile.logo_url}
      />
      <TitleText level={2} size="large">
        <TitleWrapper>
          <IconContainer>
            <CheckCircleIcon color={successColor} size="large" />
          </IconContainer>
          {i18n.t('booking.templates.cancellation_confirmed')}
        </TitleWrapper>
      </TitleText>
      {i18n.t('booking.templates.cancellation_confirmed_description', {
        name: event.publishers_list
      })}
    </Header>
  )
}
